import React, { useEffect,  } from "react";

import styled from "styled-components";
// import { getPopmenuInfo } from '@/api/base'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'
import smoothscroll from 'smoothscroll-polyfill';
import  bwmodel from '@/config/bwmodel'

// import ModalView from '@/components/modal-view'
import OpenApp from '../../components/OpenApp';
import { connect } from 'react-redux';
import h5Share from '@/utils/h5Share'
import { handleUploadTrace, jumpTo } from '@/utils'
// import { ModalContainer } from "../sku-exchange/style";
const Active_148 = ({token}) => {
  const active_id =  148;

  const userAgentInfo = navigator.userAgent;
  const mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  const mobileFlag = mobileAgents.some((mobileAgent) => {
      return userAgentInfo.indexOf(mobileAgent) > 0;
  });
  const isStorm = bwmodel.app === 'storm';


  useEffect(() => {
    
    document.title = '「热点脉冲」— 构建投资体系，助力把握投资机会';
    document.body.style = "background-color:#021759!important;"
    handleUploadTrace('ActivityPagelyuan')

    h5Share.main({
      title: `「热点脉冲」— 构建投资体系，助力把握投资机会`,
      desc: '投资逻辑课程，陪伴式服务，投研分享，排雷锦囊，脱水研报，盘面消息早知道。。',
      link: process.env.REACT_APP_DEMAND_URL + 'active_'+ active_id,
      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
    smoothscroll.polyfill();

    // getData();

  }, [])



  const handleLeftClick = () => {
  
      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})
    // }
  }



  return (
    <div>
      {
        isStorm && <Header
          title={'热点脉冲'}
          leftClick={()=> {
            handleLeftClick()
          }}
          hideNaviBar
          right={
             bwmodel.compareVersion('4.17.9') ?( <img
              onClick={()=> {
                bridge.callHandler('nativeEvent', {
                    event: 'shareLink',
                    params: {
                      // shareLinkParams:{
                      title: `「热点脉冲」— 构建投资体系，助力把握投资机会`,
                      desc: '投资逻辑课程，陪伴式服务，投研分享，排雷锦囊，脱水研报，盘面消息早知道。。',
                      thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
                      linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_148',
                    }
                  })
              }}
              style={{width:'20px','vertical-align': 'middle'}}
              src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)}
              alt="分享"
            />
              )
          :''
          }
            
        />
      }

      <Container style={{marginTop: isStorm?'44px':'0px'}} className={mobileFlag?'mobileFlag':''}>
       {/* <img className="first" src={require('./img/首图@2x.png')} alt="市值风云" /> */}
        <img className="member-img" src={require('./img/1@2x.png')} alt="热点脉冲" />
        <img className="member-img" src={require('./img/2@2x.png')} alt="热点脉冲" />
        <img className="member-img" src={require('./img/3@2x.png')} alt="热点脉冲" />
        <img className="member-img" src={require('./img/4@2x.png')} alt="热点脉冲" />
        <img className="member-img" src={require('./img/5@2x.png')} alt="热点脉冲" />
        {
          !mobileFlag &&  <div className="footer2 footer-freeclass-block" id="footer">
          <div 
            className="btn" 
            onClick={()=>{
              jumpTo(window.location.origin + '/activity/active_148/code')
            }
          }>
            <div>立即购买</div>
          </div>
        </div>
        }
        {
          mobileFlag &&  <div className="footer footer-freeclass-block" id="footer">
          <div 
            className="btn" 
            onClick={()=>{
              jumpTo(window.location.origin + '/activity/active_148/code')
            }
          }>
            <div>立即购买</div>
          </div>
        </div>
        }
       
      </Container>

      {
        !isStorm && mobileFlag &&  <OpenApp bottom = '80'  url={`${process.env.REACT_APP_DEMAND_URL}active_148`}></OpenApp>
      }
    </div>
  )
}


const Container = styled.div`
  background: #021759;
  padding-bottom:0px;
  max-width: 1080px;
  margin: 0 auto;
  
  &.mobileFlag { 
    padding-bottom:66px;
    max-width: 100%;
  }
  img {
    vertical-align: middle;
    font-size:0;
    width:100%;
  }
  .first {
    margin-bottom: -37vw;
  }
  .member-img {
    box-sizing: border-box;;
  }
   .footer2 {
    height: 65px;
    background: #021759;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
    padding: 10px 10px 0px;
    transition: bottom 0.5s;
    &.footer-freeclass-block {
        bottom: 0;
    }
    .btn {
      height: 44px;
      background: linear-gradient( 90deg, #780947 0%, #0139D3 100%);
      border-radius: 22px;
      font-size: 16px;
      color: #fff;
      text-align: center;
      position: relative;
      line-height: 44px;
      
      >span {
        position: absolute;
        right: 0px;
        width: 70px;
        height: 20px;
        background: #FF3446;
        border-radius: 0px 8px 0px 8px;
        color: #FFFFFF;
        text-decoration: line-through;
        top:0px;
        font-size:12px;
        line-height: 17px;
          
      }
    }
  }
    .tips2 {
      padding: 0;
      margin:0;
      font-weight: 300;
      font-size: 12px;
      color: #9696A6;
      line-height: 17px;
      text-align: center;
      font-style: normal;

    }
    .footer {
      height: 65px;
      background: #021759;
      box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1);
       padding: 10px 4.1vw 0px;
       position: fixed;
      left: 0;
      right: 0;
      bottom: -126px;
      z-index: 10;
      transition: bottom 0.5s;
      &.footer-freeclass-block {
          bottom: 0;
      }
      .tips{
        padding: 10px;
        color: #FFF;
        text-align:center;
        time {
          color: #FFCD88;
        }
      }
      .btn {
        height: 44px;
        background: linear-gradient( 90deg, #780947 0%, #0139D3 100%);
        border-radius: 22px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        position: relative;
        line-height: 44px;
        
        >span {
          position: absolute;
          right: 0px;
          width: 70px;
          height: 20px;
          background: #FF3446;
          border-radius: 0px 8px 0px 8px;
          color: #FFFFFF;
          text-decoration: line-through;
          top:0px;
          font-size:12px;
          line-height: 17px;
            
        }
      }
    }
@keyframes liuguang {
  00% {
    left: -105px;
  }

  20% {
    left: -15px;
  }
 
 
  100% {
    left: 50vw;
  }
}

.fixed_box {
  position: fixed;
  bottom: 120px;
  width: 48px;
  right: 10px;
}
`
// const ModalContainer = styled.div`
//   .modalCon {
//       position: relative;
//       img {
//         width:68.2vw;
//       }

//   }
//   .tips {
//     color: #FFFFFF;
//     position: absolute;
//     width:100%;
//     text-align:center;
//     top: 31vw;
//   }
//   .close {
//     display: block;
//     margin: 10px auto 0;
//   }
// `

// const ModalView =  styled.div`
//   position: fixed;
//   left: 0;
//   top: 0;
//   overflow: hidden;
//   width: 100%;
//   height: 100%;
//   z-index: 1000;
//   display: inline-block;
//   .bg {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     background: rgba(0,0,0,0.5);
//     z-index: 10;
//   }
//   .con {
//     position: absolute;
//     left: 0;
//     top: 0;
//     width: 100%;
//     height: 100%;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     z-index: 11;
//   }

// `


const mapStateToProps = (state) => ({
  token: state.user.accessToken
});

export default React.memo(connect(mapStateToProps)(Active_148))



// WEBPACK FOOTER //
// ./src/views/activity_148/index.js